import profileLogo from '../../assets/profile/profile-img.png';
import * as Styles from './styles';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../theme/useTheme';
import { ExtendedProfileHeader, ExtendedTitle } from './Title';

export default function ProfileContent(props: {
  oktaUser: any;
  iamUser: any;
}) {
  const { oktaUser, iamUser } = props;

  const empId = iamUser?.fullUser?.user?.employeeId;
  const defaultStore = iamUser?.fullUser?.stores?.filter(
    (store:any) => store.defaultStore
  );
  const storeNMame = defaultStore?.length && defaultStore[0]?.name;
  const iamDataExists = empId || storeNMame;
  const {t} = useTranslation();
  const { darkMode } = useTheme();

  const getPhoneNumber = (contactList: any, oktaPhone: string | undefined) => {
    return oktaPhone && oktaPhone !== '' ? oktaPhone : (contactList && contactList.length > 0
      ? (contactList.find((x: any) => x.typeCode === 'Phone' && !x.secondary)?.value
      || contactList.find((x: any) => x.typeCode === 'Phone' && x.secondary)?.value
      || '')
      : '');
  }

  return (
    <>
      <ExtendedProfileHeader themeType={darkMode}>
        <ExtendedTitle themeType={darkMode}>
          <Styles.ProfileImage data-testid="user-img" src={profileLogo} />
          <div style={{marginLeft:'20px'}}>
            <h2 data-testid="user-name">
              {oktaUser.profile?.firstName} {oktaUser.profile?.lastName}
            </h2>
            <h4 style={{marginTop:'-2px',fontWeight:'400'}}>{iamUser?.fullUser?.enterprise?.name}</h4>
          </div>
        </ExtendedTitle>
      </ExtendedProfileHeader>
      <Styles.ProfileBody>
        {iamDataExists && (
          <>
            <h2>{t('profile.details')}</h2>
            <Styles.Details>
              {empId && (
                <>
                  <Styles.Label data-testid="label-phone">
                    {t('profile.empID')}
                  </Styles.Label>
                  <Styles.Value data-testid="value-phone">{empId}</Styles.Value>
                </>
              )}
              {storeNMame && (
                <>
                  <Styles.Label data-testid="label-email">
                    {t('profile.store')}
                  </Styles.Label>
                  <Styles.Value data-testid="value-email">
                    &nbsp;
                    {storeNMame}
                  </Styles.Value>
                </>
              )}
            </Styles.Details>
          </>
        )}
        <h2>{t('profile.contactInfo')}</h2>
        <Styles.Details>
          <Styles.Label data-testid="label-phone">
            {t('profile.phone')}
          </Styles.Label>
          <Styles.Value data-testid="value-phone">
            {getPhoneNumber(iamUser?.fullUser?.contacts, oktaUser.profile?.mobilePhone)}
          </Styles.Value>
          <Styles.Label data-testid="label-email">
            {t('profile.email')}
          </Styles.Label>
          <Styles.Value data-testid="value-email">
            &nbsp;
            {oktaUser.profile?.email}
          </Styles.Value>
        </Styles.Details>
      </Styles.ProfileBody>
    </>
  );

}
